module.exports = "//static.hsappstatic.net/ecosystem-marketplace-apps-base/static-1.9418/img/video-thumb-overlay.png"